/**
 * @private
 * @hide
 */
export function convertToArray(locale) {
  if (Array.isArray(locale)) {
    return locale;
  }
  return [locale];
}

/**
 * @private
 * @hide
 */
export function convertToString(locale) {
  if (Array.isArray(locale)) {
    return locale[0];
  }
  return locale;
}
/**
 * @private
 * @hide
 */
export function hasLocaleChanged(locale1, locale2) {
  if (!Array.isArray(locale2)) {
    return true;
  }
  return locale1.toString() !== locale2.toString();
}

/**
 * @private
 * @hide
 */
export function normalizeLocale(locale) {
  return locale.replace(/_/g, '-').toLowerCase();
}